import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../makeRequest";

async function deletePostApi(id: string) {
  const data = await makeRequest(`/api/admin/deletepost?id=${id}`, {
    method: "DELETE",
  });

  if (!data || data.error) {
    throw new Error(data?.error || "Failed to delete post");
  }

  return data; // contains success:true, post_id, message
}

export function useDeletePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deletePostApi(id),   // <-- FIXED
    onSuccess: (response, id) => {
      console.log("Deleted post:", id);

      queryClient.invalidateQueries({ queryKey: ["posts"] });
      queryClient.invalidateQueries({ queryKey: ["adminallposts"] });
    },
    onError: (error: any) => {
      console.error("Failed to delete post:", error.message);
    },
  });
}